import Lara from "@/presets/lara";

export const filtersPresets = {
  ...Lara,
  sidebar: {
    ...Lara.sidebar,
    header: [...Lara.sidebar.header.class, "!bg-teal-accent", "!py-3"],
    closeButtonIcon: [...Lara.sidebar.closeButtonIcon.class, "!text-university-primary"],
    content: { class: [...Lara.sidebar.content.class, "flex", "flex-col", "justify-between", "!p-0"] },
    root: (args) => ({ class: [...Lara.sidebar.root(args).class, "!w-[480px]"] }),
  },
  accordion: {
    // ...Lara.accordiontab,
    root: {
      class: ["mb-1", "border-solid", "border-b", "border-slate-200"],
    },
    accordiontab: {
      header: ({ props }) => ({
        class: [
          // State
          {
            "select-none pointer-events-none cursor-default opacity-60": props?.disabled,
          },

          "my-6",

          //Font
          "font-montserrat",
          "text-normal",
          "!font-normal",
          "text-gray-900",
          "capitalize",
        ],
      }),
      headerAction: ({ context }) => ({
        class: [
          //Font
          "leading-none",

          // Alignments
          "flex flex-row-reverse items-center justify-between",
          "relative",

          // Color
          "text-surface-600 dark:text-surface-0/80",
          { "text-surface-900": context.active },

          // Transition
          "transition duration-200 ease-in-out",
          "transition-shadow duration-200",

          // States

          "hover:text-surface-900",
          "focus:outline-none focus:outline-offset-0 focus-visible:ring focus-visible:ring-primary-400/50 ring-inset dark:focus-visible:ring-primary-300/50", // Focus

          // Misc
          "cursor-pointer no-underline select-none",
        ],
      }),
      headerIcon: {
        class: "inline-block m-1",
      },
      headerTitle: {
        class: "",
      },
      content: {
        class: [
          // Spacing
          "flex-col justify-between",
        ],
      },
      toggleableContent: {
        class: [],
      },
      transition: {
        enterFromClass: "max-h-0",
        enterActiveClass: "overflow-hidden transition-[max-height] duration-1000 ease-[cubic-bezier(0.42,0,0.58,1)]",
        enterToClass: "max-h-[1000px]",
        leaveFromClass: "max-h-[1000px]",
        leaveActiveClass: "overflow-hidden transition-[max-height] duration-[450ms] ease-[cubic-bezier(0,1,0,1)]",
        leaveToClass: "max-h-0",
      },
    },
  },
  button: {
    ...Lara.button,
    label: (args) => ({
      class: ["uppercase", "font-light", "text-normal"],
    }),
    root: (args) => ({
      class: [],
    }),
  },
  checkbox: {
    ...Lara.checkbox,
    root: { class: [...Lara.checkbox.root.class, "!w-4", "!h-4", "cursor-none"] },
    input: (args) => {
      const { context, props } = args;
      return {
        class: [...Lara.checkbox.input.class, { "!bg-gray-400 !opacity-20 !cursor-not-allowed": props.disabled }],
      };
    },
    box: (args) => {
      const { context, props } = args;
      return {
        class: [
          ...Lara.checkbox.box(args).class,
          "!border-black",
          "!w-4",
          "!h-4",
          { "!bg-black": context.checked && !props.disabled },
          { "!bg-gray-400 !opacity-20 !cursor-not-allowed": props.disabled },
        ],
      };
    },
  },
  calendar: {
    ...Lara.calendar,
    root: (args) => ({
      class: [...Lara.calendar.root(args).class, "!w-full", "!mr-4"],
    }),
    input: (args) => ({
      class: [...Lara.calendar.input(args).class, "!rounded-none", "!w-full"],
    }),
    dropdownbutton: {
      ...Lara.calendar.dropdownbutton,
      root: {
        class: [
          ...Lara.calendar.dropdownbutton.root.class,
          "!rounded-none",
          "!bg-transparent",
          "!text-slate-500",
          "!border-slate-300",
          "!border-l-0",
        ],
      },
    },
  },
  listbox: {
    ...Lara.listbox,
    header: {
      class: [...Lara.listbox.header.class, "!border-none", "!bg-white"],
    },
    filterinput: {
      class: [...Lara.listbox.filterinput.class, "!text-gray-600", "!border-black", "!rounded-none"],
    },
    filtericon: { class: ["hidden"] },
    item: (args) => ({
      class: [...Lara.listbox.item(args).class, "!bg-white"],
    }),
  },
  sortByButton: {
    ...Lara.button,
    label: { class: [] },
    root: (args) => ({
      class: [...Lara.button.root(args).class, "!border-grey", "flex", "flex-row-reverse"],
    }),
  },
  sortByMenu: {
    ...Lara.menu,
    submenuheader: {
      class: ["hidden"],
    },
  },
};
